/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */
import React, { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { Image, Modal } from 'react-bootstrap';

import './ProductInfoModal.scss';
import { ItemInfoStore } from '../model/ItemInfoStore';
import './SocialLinkItemInfoModal.scss';
import { MoneyDisplay } from '../../order-selection/starter-kit-selection/util-starter-kit/MoneyDisplay';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  itemInfo: ItemInfoStore;
  priceDisplay: ReactNode;
}

export const ItemInfoModal = observer<Props>(function YlModal({ isOpen, onClose, itemInfo, priceDisplay }) {
  const getHtml = (text: any) => (text ? text.split('"\r\n\r\n"').toString() : undefined);
  const description = itemInfo.description ?? itemInfo.shortDescription;
  if (!isOpen) {
    return <></>;
  }

  return (
    <Modal show={isOpen} onHide={onClose} className="sl-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          <p className="d-flex ml-2 sl-modal-title justify-content-start">{itemInfo.name}</p>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={isOpen ? 'd-block' : 'd-none'}>
        <div className={!itemInfo.imageExpanded ? 'd-block text-left' : 'd-none text-left'}>
          <div className="d-flex justify-content-start sl-modal-container">
            <div className="sl-modal-image-container">
              <Image className="sl-modal-image" src={itemInfo.imageUrl} />
            </div>
            <div className="sl-modal-partnum-pv-container">
              <div className="sl-modal-pv-label">
                Item Number:{''}
                <span className="sl-modal-pv-value">{itemInfo.partNumber}</span>
              </div>
              <div className="sl-modal-pv-label">
                PV:{' '}
                <span className="sl-modal-pv-value">
                  {itemInfo.pointValue && <MoneyDisplay numberOnly price={itemInfo.pointValue} />}
                </span>
              </div>
            </div>
            <div className="sl-modal-description" dangerouslySetInnerHTML={{ __html: getHtml(description) }} />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});
